<template>
  <div class="bg-nav">
    <!-- NAVBAR -->
    <div>
      <Navbar />
    </div>
    <div
      class="bg-products-cot h-auto mb-12 mt-8"
      style="height: auto !important"
    >
      <div class="container">
        <router-link
          :to="{ name: 'catalogue' }"
          class="text-blue-500 hover:underline text-lg"
        >
          <ArrowLeftIcon /> Regresar</router-link
        >
        <!-- CATALOGUE -->
        <div
          v-if="productData && clients && channels && quotation"
          class="grid grid-cols-12 gap-4 mb-6"
        >
          <div class="sm:col-span-4 col-span-12 text-right">
            <SliderProducts
              :product="productData"
              v-model:productColor="quotation.productColorSelected"
              @change-favorite-product="changeFavoriteProduct"
            />
            <div
              class="grid grid-cols-2 gap-4 text-left bg-white p-4 mt-10 mb-6 shadow-sm rounded-2xl"
            >
              <div>
                <h3 class="font-poppins text-theme-32 text-xs">
                  No. de cajas master
                </h3>
                <h2 class="font-poppins text-black font-bold text-base">
                  {{ masterBoxQuantity }}
                </h2>
                <h3 class="font-poppins text-theme-32 text-xs">
                  Tiempos de entrega
                </h3>
                <h2 class="font-poppins text-black font-bold text-base">
                  {{ daysApproxDelivery }}
                </h2>
              </div>
              <div>
                <h3 class="font-poppins text-theme-32 text-xs">
                  Precio unitario
                </h3>
                <h2 class="font-poppins text-black font-bold text-base">
                  {{ basePrice ? formatter.format(basePrice) + ' MXN' : '-' }}
                </h2>
                <h3 class="font-poppins text-theme-32 text-xs">
                  Subtotal (Con envío estándar)
                </h3>
                <h2 class="font-poppins text-theme-33 font-bold text-base">
                  {{
                    priceQuotation
                      ? formatter.format(priceQuotation) + ' MXN'
                      : '-'
                  }}
                </h2>
              </div>
            </div>
            <div class="text-center">
              <button
                v-if="isCpaCompany"
                type="button"
                class="bg-theme-33 text-white font-semibold rounded-lg w-60 h-14 font-poppins text-center disabled:cursor-not-allowed disabled:opacity-30"
                :disabled="!checkQuotation"
                @click="createQuotation"
              >
                Guardar cotización
              </button>
              <button
                v-else-if="!isEditStatus"
                type="button"
                class="bg-theme-33 text-white font-semibold rounded-lg w-60 h-14 font-poppins text-center disabled:cursor-not-allowed disabled:opacity-30"
                :disabled="!checkQuotation"
                @click="addQuotationToCart"
              >
                <p v-if="currentQuotation == undefined">
                  Agregar cotización al carrito
                </p>
                <p v-else>Actualizar cotización del carrito</p>
              </button>
              <button
                v-else
                type="button"
                class="bg-theme-33 text-white font-semibold rounded-lg w-60 h-14 font-poppins text-center disabled:cursor-not-allowed disabled:opacity-30"
                :disabled="!checkQuotation"
                @click="updateQuotationStatus"
              >
                Actualizar cotización
              </button>
            </div>
          </div>
          <div class="sm:col-span-8 col-span-12 pl-4">
            <div>
              <h1 class="font-crimson_pro font-bold text-3xl text-theme-9">
                {{ productData.name }}
              </h1>
              <h6 class="text-theme-32 text-xs">SKU: {{ productData.sku }}</h6>
            </div>
            <div class="mt-3">
              <p class="font-poppins text-base">
                {{ productData.description }}
              </p>
            </div>
            <div class="flex mt-3">
              <h1
                class="font-poppins font-medium text-base text-center align-middle align-items-lg-start py-2 mr-2"
              >
                Categoría:
              </h1>
              <template
                v-if="
                  Array.isArray(productData.product_types) &&
                  productData.product_types.length
                "
              >
                <span
                  class="min-w-[128px] h-9 rounded-md bg-theme-7 text-white text-center align-middle align-items-lg-start p-2 mr-2"
                  v-for="category in productData.product_types || []"
                  :key="category.id"
                >
                  {{ category.name }}
                </span>
              </template>
              <span
                class="w-32 h-9 rounded-md bg-theme-7 text-white text-center align-middle align-items-lg-start p-2 mr-2"
                v-else
              >
                Sin categoría
              </span>
            </div>
            <div class="mt-3">
              <h1 class="font-poppins font-medium text-base py-2">Color</h1>
              <div class="grid grid-cols-12 gap-1">
                <div
                  v-for="colorData in productData?.productcolors || []"
                  :key="colorData.id"
                >
                  <a
                    href="javascript:;"
                    class="color-picker"
                    :class="{
                      'color-picker-active':
                        colorData === quotation.productColorSelected
                    }"
                    :style="{ background: colorData.color }"
                    @click="quotation.productColorSelected = colorData"
                  ></a>
                </div>
              </div>
            </div>
            <div>
              <div v-if="isCpaCompany" class="mt-3 w-full">
                <label class="form-label w-full font-poppins text-sm">
                  Cliente
                </label>
                <select
                  class="form-select form-select-lg sm:w-1/2 w-full bg-theme-11 border-theme-3"
                  v-model="quotation.client_id"
                >
                  <option :value="undefined" disabled>Elige un cliente</option>
                  <option
                    v-for="client in clients || []"
                    :key="client.id"
                    :value="client.id"
                  >
                    {{ client.name }}
                  </option>
                </select>
              </div>
              <div v-if="isCpaCompany" class="mt-3 w-full">
                <label class="form-label w-full font-poppins text-sm">
                  Marca
                </label>
                <select
                  class="form-select form-select-lg sm:w-1/2 w-full bg-theme-11 border-theme-3"
                  v-model="quotation.brand_id"
                >
                  <option :value="undefined" disabled>Elige una marca</option>
                  <option
                    v-for="brand in brands || []"
                    :key="brand.id"
                    :value="brand.id"
                  >
                    {{ brand.name }}
                  </option>
                </select>
              </div>
              <div v-if="isCpaCompany" class="mt-3 w-full">
                <label class="form-label w-full font-poppins text-sm">
                  Tipo de canal
                </label>
                <select
                  class="form-select form-select-lg sm:w-1/2 w-full bg-theme-11 border-theme-3"
                  v-model="quotation.channel_id"
                >
                  <option :value="undefined" disabled>Elige un canal</option>
                  <option
                    v-for="channel in channels || []"
                    :key="channel.id"
                    :value="channel.id"
                  >
                    {{ channel.name }}
                  </option>
                </select>
              </div>
              <div class="mt-3">
                <label
                  for="regular-form-1"
                  class="form-label w-full font-poppins text-sm"
                  >Volumen de venta (pzas)
                </label>
                <input
                  type="number"
                  :min="minUnitsQuotation"
                  :max="maxUnitsQuotation"
                  class="form-control sm:w-1/2 w-full bg-theme-11 border-theme-3 font-poppins text-base"
                  placeholder="No. de piezas"
                  v-model="quotation.units"
                />
                <div
                  v-if="!isSpecialQuote"
                  class="form-help"
                  :class="{
                    'text-theme-6':
                      quotation.units &&
                      (quotation.units < minUnitsQuotation ||
                        quotation.units > maxUnitsQuotation)
                  }"
                >
                  NOTA: Este producto tiene un mínimo de venta de
                  {{ numberFormatter.format(minUnitsQuotation) }} y un máximo de
                  {{ numberFormatter.format(maxUnitsQuotation) }} pzs
                </div>
              </div>
              <div v-if="!isSpecialQuote" class="mt-3">
                <label
                  for="regular-form-1"
                  class="form-label w-full font-poppins text-sm"
                  >Tipo de personalización</label
                >
                <select
                  class="form-select form-select-lg sm:w-1/2 w-full bg-theme-11 border-theme-3"
                  v-model="printTypeId"
                >
                  <option :value="undefined" disabled>Elige un tipo</option>
                  <option
                    v-for="(pt, key) in printingTypes"
                    :key="key"
                    :value="pt.id"
                  >
                    {{ pt.name }}
                  </option>
                </select>
                <div v-if="!isSpecialQuote" class="form-help sm:w-1/2">
                  Los costos y las técnicas de personalización son propuestas
                  que se validaran de forma oficial al momento de la respuesta
                  de cotización.
                </div>
              </div>
              <div v-if="!isSpecialQuote" class="mt-3">
                <label
                  for="regular-form-1"
                  class="form-label w-full font-poppins textlsm"
                  >{{
                    labelTypePersonalization
                      ? 'Tintas de impresión'
                      : 'Medidas mínimas - máximas'
                  }}</label
                >
                <select
                  class="form-select form-select-lg sm:w-1/2 w-full bg-theme-11 border-theme-3"
                  v-model="customizationId"
                >
                  <option :value="undefined" disabled>
                    {{
                      labelTypePersonalization
                        ? 'Elige una tinta'
                        : 'Elige medidas mínimas - máximas'
                    }}
                  </option>
                  <option
                    v-for="(customization, key) in customizationsFilter"
                    :key="key"
                    :value="customization.id"
                  >
                    {{ customization.name }}
                  </option>
                </select>
              </div>
              <div v-if="!isSpecialQuote" class="mt-3">
                <label class="form-label w-full font-poppins text-sm">
                  No. de posiciones
                </label>
                <input
                  type="number"
                  :min="1"
                  class="form-control sm:w-1/2 w-full bg-theme-11 border-theme-3 font-poppins text-base"
                  placeholder="No. de posiciones"
                  v-model="quotation.numberOfPositions"
                  :disabled="true"
                />
              </div>
              <div class="mt-3">
                <p class="font-poppins text-base">
                  Para una cotización más precisa o especial, favor de incluir
                  las siguientes especificaciones en el apartado de cotización
                  especial:
                  <b
                    >número de piezas, costo objetivo, fecha de entrega, lugar
                    de entrega, tipo de personalización, logo y descripción del
                    producto. Todo esto en un solo archivo.</b
                  >
                </p>
                <a
                  class="text-blue-500 hover:underline"
                  download="Plantilla de cotización especial"
                  target="_blank"
                  href="/plantilla_CE.xlsx"
                >
                  Descarga el template que está abajo.
                </a>
              </div>
              <div class="mt-3">
                <div class="form-check mt-2">
                  <input
                    id="checkbox-switch-1"
                    class="form-check-input w-5 h-5 border-2 border-theme-11"
                    type="checkbox"
                    v-model="quotation.special_quotation"
                    :disabled="isSpecialQuote"
                  />
                  <label
                    class="form-check-label font-poppins text-base"
                    for="checkbox-switch-1"
                    >Necesito una cotización especial
                  </label>
                </div>
              </div>
              <div class="mt-3">
                <div class="input-form mt-3">
                  <label class="form-label w-full flex flex-col sm:flex-row">
                    <span
                      class="sm:mr-auto mt-1 sm:mt-0 text-xs text-slate-500 text-left font-normal"
                      >Requerimientos adicionales
                    </span>
                  </label>
                  <textarea
                    id="validation-form-6"
                    class="form-control disabled:bg-theme-11 border-theme-3 font-poppins"
                    v-model="quotation.additional_requirements"
                    placeholder="Escribe aquí tus requerimientos"
                    :disabled="!quotation.special_quotation"
                    :maxLength="1000"
                  >
                  </textarea>
                  <div class="flex flex-row justify-end text-gray-600 text-xs">
                    <p>{{ quotation?.additional_requirements?.length || 0 }}</p>
                    <p>/</p>
                    <p>1,000 caracteres</p>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                Si cuentas con un archivo de distribución puedes adjuntarlo aquí
              </div>
              <div class="mt-3">
                <input
                  type="file"
                  accept=".xlsx,.xls,.xlsm,.csv,.pdf"
                  ref="quotationFileRef"
                  style="display: none"
                  @change="onFileDataChange"
                />
                <input
                  type="text"
                  v-model="quotation.quotationFile.name"
                  :readonly="true"
                  class="form-control sm:w-1/2 w-full disabled:bg-theme-11 border-theme-3 font-poppins text-base cursor-pointer"
                  placeholder="Seleccionar archivo"
                  @click="$refs.quotationFileRef.click()"
                  :disabled="!quotation.special_quotation"
                />
                <button
                  class="btn btn-quotation rounded-lg w-[70px] text-base disabled:opacity-50"
                  type="button"
                  :disabled="!quotation.special_quotation"
                  @click="$refs.quotationFileRef.click()"
                >
                  Cargar
                </button>
              </div>
              <div class="mt-3">
                <h1 class="font-bold text-lg font-poppins">Especificaciones</h1>
              </div>
              <div class="mt-3">
                <div class="flex flex-col md:flex-row gap-4">
                  <div>
                    <button
                      class="w-full md:w-40 h-10 rounded font-poppins"
                      :class="{
                        'bg-theme-29':
                          quotation.informationSelected === 'BASIC',
                        'text-black': quotation.informationSelected === 'BASIC',
                        'bg-transparent':
                          quotation.informationSelected !== 'BASIC',
                        border: quotation.informationSelected !== 'BASIC',
                        'border-theme-3':
                          quotation.informationSelected !== 'BASIC'
                      }"
                      @click="quotation.informationSelected = 'BASIC'"
                    >
                      Inf. básica
                    </button>
                  </div>
                  <div>
                    <button
                      class="w-full md:w-40 h-10 rounded font-poppins"
                      :class="{
                        'bg-theme-29':
                          quotation.informationSelected === 'PRINTING',
                        'text-black':
                          quotation.informationSelected === 'PRINTING',
                        'bg-transparent':
                          quotation.informationSelected !== 'PRINTING',
                        border: quotation.informationSelected !== 'PRINTING',
                        'border-theme-3':
                          quotation.informationSelected !== 'PRINTING'
                      }"
                      @click="quotation.informationSelected = 'PRINTING'"
                    >
                      Inf. de impresión
                    </button>
                  </div>
                  <div>
                    <button
                      class="w-full md:w-40 h-10 rounded font-poppins"
                      :class="{
                        'bg-theme-29':
                          quotation.informationSelected === 'PACKAGING',
                        'text-black':
                          quotation.informationSelected === 'PACKAGING',
                        'bg-transparent':
                          quotation.informationSelected !== 'PACKAGING',
                        border: quotation.informationSelected !== 'PACKAGING',
                        'border-theme-3':
                          quotation.informationSelected !== 'PACKAGING'
                      }"
                      @click="quotation.informationSelected = 'PACKAGING'"
                    >
                      Inf. de empaque
                    </button>
                  </div>
                </div>
                <div class="mt-3">
                  <div class="overflow-x-auto">
                    <table
                      style="width: 100%; text-align: left"
                      class="font-poppins"
                      aria-describedby="Información del producto"
                    >
                      <template
                        v-if="quotation.informationSelected === 'BASIC'"
                      >
                        <tr>
                          <th>Categoría</th>
                          <td>{{ productData.material?.name }}</td>
                        </tr>
                        <tr>
                          <th>Medida</th>
                          <td>
                            {{ productData.length }} x {{ productData.width }} x
                            {{ productData.height }} cm
                          </td>
                        </tr>
                        <tr>
                          <th>Capacidad</th>
                          <td>{{ productData.unit_measure || '-' }}</td>
                        </tr>
                      </template>
                      <template
                        v-else-if="quotation.informationSelected === 'PRINTING'"
                      >
                        <tr>
                          <th>Técnica</th>
                          <td>{{ printingTypesDescription }}</td>
                        </tr>
                        <tr>
                          <th>Área</th>
                          <td>{{ printingAreasDescription }}</td>
                        </tr>
                      </template>
                      <template
                        v-else-if="
                          quotation.informationSelected === 'PACKAGING'
                        "
                      >
                        <tr>
                          <th>Medida caja master</th>
                          <td>
                            {{ productData.containerbox?.length || '-' }}
                            x
                            {{ productData.containerbox?.width || '-' }}
                            x
                            {{ productData.containerbox?.height || '-' }}
                            cm ({{
                              productData.containerbox?.masterbox?.box_type
                                ?.size || '-'
                            }})
                          </td>
                        </tr>
                        <tr>
                          <th>Peso</th>
                          <td>{{ productData.weight }} gramos</td>
                        </tr>
                        <tr>
                          <th>Caja individual</th>
                          <td>{{ checkContainerBox ? 'Sí' : 'No' }}</td>
                        </tr>
                        <tr>
                          <th>Cantidad de piezas x caja master</th>
                          <td>
                            {{
                              productData.containerbox?.masterbox
                                ?.max_total_containers || '-'
                            }}
                            pza(s)
                          </td>
                        </tr>
                      </template>
                    </table>
                  </div>
                </div>
                <div class="mt-6">
                  <h1 class="font-bold font-poppins text-lg">NOTAS</h1>
                  <ul class="font-poppins text-base list-disc mt-3">
                    <li>
                      El costo de envío es variable, ponte en contacto con tu
                      ejecutivo de ventas para más información.
                    </li>
                    <li>
                      Los tipos de impresión dependerán del volumen de unidades
                      a solicitar
                    </li>
                    <li>Todos los productos se entregan en la CDMX</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="!productLoader && !productData"
          class="flex flex-col w-full h-full justify-center items-center"
        >
          <img src="@/assets/images/empty-product.png" alt="product empty" />
          <p class="font-bold text-3xl">Lo sentimos</p>
          <p>El producto no ha sido encontrado</p>
        </div>
        <div v-else class="flex justify-center h-screen w-screen items-center">
          <span class="animate-spin">
            <loaderIcon />
          </span>
        </div>
        <div v-if="productData" class="container mx-auto my-4">
          <div>
            <h1 class="font-crimson_pro font-bold text-3xl text-theme-9 my-8">
              Productos relacionados
            </h1>
          </div>
          <div class="grid grid-cols-12 gap-4 mb-6">
            <div class="sm:col-span-9 col-span-12">
              <div class="grid sm:grid-cols-3 grid-cols-2 gap-4">
                <div
                  class="b-cot-card min-h-[288px] p-4 sm:max-w-[192px] md:max-w-[296px] w-full cursor-pointer"
                  style="background-color: #f4f4f45c"
                  v-for="product in releatedProducts"
                  :key="product.id"
                  :title="product.name"
                >
                  <div class="grid grid-cols-4 gap-4">
                    <div class="col-span-3" @click="goToProduct(product)">
                      <h1
                        class="text-theme-9 font-poppins font-medium truncate"
                      >
                        {{ product.name }}
                      </h1>
                    </div>
                    <div>
                      <span @click="changeFavoriteProduct(product.id)">
                        <heartIcon
                          :class="{
                            'text-transparent':
                              !product?.users_favorite?.length,
                            'text-theme-9': product?.users_favorite?.length
                          }"
                          class="font-poppins font-medium fill-current"
                          :style="{
                            stroke: !product?.users_favorite?.length
                              ? '#a13122'
                              : 'currentColor'
                          }"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    class="w-44 h-40 mx-auto my-4"
                    style="background: #ffffff7a; border-radius: 24px"
                    @click="goToProduct(product)"
                  >
                    <img
                      :src="getProductImage(product)"
                      alt="Imagen del producto"
                      class="h-40 object-contain m-auto rounded"
                      crossorigin="anonymous"
                    />
                  </div>
                  <div
                    class="grid grid-cols-2 gap-4"
                    @click="goToProduct(product)"
                  >
                    <div class="text-xs font-poppins">
                      Mínimo
                      {{
                        product?.customizations?.length
                          ? product.customizations
                              .map((c) => c.sale_volume)
                              .sort(
                                (a, b) => a.minimum_units - b.minimum_units
                              )[0]
                              .minimum_units.toLocaleString()
                          : 0
                      }}
                      pzas
                    </div>
                    <div class="text-xs font-poppins">
                      Desde
                      {{
                        formatter.format(
                          product?.customizations?.length
                            ? product.customizations.sort(
                                (a, b) => a.base_price - b.base_price
                              )[0].base_price
                            : 0
                        )
                      }}
                      MXN
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="productData && clients && quotation">
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/navbar/Main.vue'
import Footer from '@/components/footer/Main.vue'
import SliderProducts from '@/components/slider-products/Main.vue'
import {
  cleanSession,
  getFirstErrorMessage,
  formatter,
  numberFormatter
} from '@/utils/tools'
import { mapGetters } from 'vuex'

export default {
  components: {
    Navbar,
    Footer,
    SliderProducts
  },
  data() {
    return {
      creatingQuotation: false,
      formatter: formatter,
      numberFormatter: numberFormatter,
      productData: undefined,
      clients: undefined,
      channels: undefined,
      brands: [],
      printTypeId: undefined,
      inkValues: {},
      customizationsFilter: undefined,
      customizationId: undefined,
      inkSelected: undefined,
      defaultQuotationFile: {
        file: undefined,
        name: ''
      },
      defaultQuotation: {
        productColorSelected: undefined,
        units: undefined,
        saleVolumeSelected: undefined,
        client_id: undefined,
        brand_id: undefined,
        channel_id: undefined,
        productPrintingSelected: undefined,
        numberOfPositions: 1,
        special_quotation: false,
        additional_requirements: undefined,
        quotationFile: undefined,
        informationSelected: 'BASIC'
      },
      quotation: undefined,
      currentQuotation: undefined,
      isEditStatus: false,
      productLoader: false
    }
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    const quotationId = parseInt(this.$route.query.quotationId) || 0
    const productId = parseInt(this.$route.params.id) || 0
    this.isEditStatus = this.$route.query?.status === 'edit'

    await Promise.all([
      this.setViewProduct(productId),
      this.getProductData(productId),
      this.getClients(),
      this.getChannels()
    ])

    if (quotationId && !this.isEditStatus) {
      let currentQuotation = this.$store.getters[
        'cart/getCart'
      ]?.quotations?.find(
        (quotation) => Number(quotation.id) === Number(quotationId)
      )
      if (!currentQuotation) {
        const response = await this.axios.get('sales-operator/cart', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`,
            'Content-Type': 'multipart/form-data',
            Accept: 'application/json'
          }
        })
        this.$store.commit(
          'cart/setCountQuotations',
          response?.data?.multi_quotation?.quotations?.length || 0
        )

        this.$store.commit(
          'cart/setCartData',
          response?.data?.multi_quotation || []
        )
        this.$store.commit(
          'cart/setProductsInterests',
          response?.data?.product_interests || []
        )
        currentQuotation = response?.data?.multi_quotation?.quotations?.find(
          (quotation) => Number(quotation.id) === Number(quotationId)
        )
      }
      this.currentQuotation = currentQuotation
      this.quotation.units = currentQuotation.historic_prices[0].units
      this.quotation.special_quotation = currentQuotation.special_quotation
      if (this.currentQuotation.file) {
        await fetch(this.currentQuotation.file)
          .then((response) => {
            const urlSplit = response.url.split('/')

            // Try to get filename from Content-Disposition header
            const contentDisposition = response.headers.get(
              'Content-Disposition'
            )
            let fileName = urlSplit[urlSplit.length - 1]

            if (
              contentDisposition &&
              contentDisposition.includes('filename=')
            ) {
              const match = /filename="([^"]+)"/.exec(contentDisposition)
              if (match && match[1]) {
                fileName = match[1]
              }
            }

            return response.blob().then((blob) => ({ blob, fileName }))
          })
          .then(({ blob, fileName }) => {
            this.quotation.quotationFile = {
              file: blob,
              name: fileName
            }
            this.$refs.quotationFileRef.value = blob
          })
          .catch((error) => console.error('Error:', error))
      }

      setTimeout(() => {
        this.quotation.additional_requirements =
          currentQuotation.additional_requirements
        this.printTypeId = this.currentQuotation.print_type_id
        setTimeout(() => {
          this.customizationId =
            this.currentQuotation?.product?.customizations?.find(
              (cItem) =>
                cItem.customization.print_type_id ===
                  this.currentQuotation.print_type_id &&
                cItem.customization.personalization ==
                  this.currentQuotation.printing_area &&
                cItem.sale_volume.minimum_units <= this.quotation.units &&
                cItem.sale_volume.maximum_units >= this.quotation.units
            )?.customization?.id || undefined
        }, 100)
      }, 300)
    }

    if (this.isEditStatus && quotationId) {
      const response = await this.axios.get(
        `sales-operator/quotations/${quotationId}/data`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        }
      )
      const lastStatus = response.data.quotation.quotation_statuses[0]
      const lastHistoricPrice = lastStatus.quotation_status_historic_prices[0]
      this.currentQuotation = lastStatus
      this.quotation.id = quotationId
      this.quotation.units = lastHistoricPrice.units
      this.quotation.special_quotation = lastStatus.special_quotation

      if (this.currentQuotation.file) {
        await fetch(this.currentQuotation.file)
          .then((response) => {
            const urlSplit = response.url.split('/')

            // Try to get filename from Content-Disposition header
            const contentDisposition = response.headers.get(
              'Content-Disposition'
            )
            let fileName = urlSplit[urlSplit.length - 1]

            if (
              contentDisposition &&
              contentDisposition.includes('filename=')
            ) {
              const match = /filename="([^"]+)"/.exec(contentDisposition)
              if (match && match[1]) {
                fileName = match[1]
              }
            }

            return response.blob().then((blob) => ({ blob, fileName }))
          })
          .then(({ blob, fileName }) => {
            this.quotation.quotationFile = {
              file: blob,
              name: fileName
            }
            this.$refs.quotationFileRef.value = blob
          })
          .catch((error) => console.error('Error:', error))
      }

      setTimeout(() => {
        this.quotation.additional_requirements =
          lastStatus.additional_requirements
        this.printTypeId = this.currentQuotation.print_type_id
        setTimeout(() => {
          this.customizationId =
            response.data?.quotation?.product?.customizations?.find(
              (cItem) =>
                cItem.customization.print_type_id ===
                  this.currentQuotation.print_type_id &&
                cItem.customization.personalization ==
                  this.currentQuotation.printing_area &&
                cItem.sale_volume.minimum_units <= this.quotation.units &&
                cItem.sale_volume.maximum_units >= this.quotation.units
            )?.customization?.id || undefined
        }, 150)
      }, 300)
    }

    this.$store.commit('main/setShowSpinner', false)
  },
  methods: {
    async getProductData(productId) {
      this.productLoader = true
      try {
        this.productData = undefined
        this.quotation = { ...this.defaultQuotation }
        this.quotation.quotationFile = { ...this.defaultQuotationFile }
        const response = await this.axios.get(
          `sales-operator/products/product-by-id-and-sales-operator/${productId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        const productData = response.data?.product

        if (
          Array.isArray(productData.productcolors) &&
          productData.productcolors.length
        ) {
          this.quotation.productColorSelected = productData.productcolors[0]
        }
        this.productData = {
          ...productData,
          customizations: productData.customizations.map((cElement) => {
            return {
              ...cElement,
              sale_volume: {
                ...cElement.sale_volume,
                cost_per_unit:
                  cElement?.customization?.sales_volume?.find(
                    (sv) => sv.id == cElement.sale_volume.id
                  )?.pivot?.cost_per_unit || null
              }
            }
          })
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.productLoader = false
      }
    },
    async getClients() {
      try {
        const response = await this.axios.get('common/all-clients', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.clients = response.data?.clients || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async setViewProduct(productId) {
      try {
        await this.axios.post(
          'sales-operator/product-views/add-product-view',
          {
            product_id: productId
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async getChannels() {
      try {
        const response = await this.axios.get('common/all-channels', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.channels = response.data?.channels || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    getProductImage(product) {
      return Array.isArray(product.image) && product.image.length
        ? product.image[0]
        : product.image !== null && !Array.isArray(product.image)
        ? product.image
        : require(product.sku !== 'COTESPI001'
            ? '@/assets/images/product.svg'
            : '@/assets/images/COTESPI001.svg')
    },
    goToProduct(product) {
      this.$router.push({ name: 'products', params: { id: product.id } })
    },
    async changeFavoriteProduct(productId) {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          'sales-operator/favorite-products/edit-favorite-product',
          {
            product_id: productId
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        await this.getProductData(this.productData.id || 0)
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    onFileDataChange(event) {
      if (event.target.files.length) {
        this.quotation.quotationFile = {
          file: event.target.files[0],
          name: event.target.files[0].name
        }
      } else {
        this.cleanFile()
      }
    },
    cleanFile() {
      this.quotation.quotationFile = { ...this.defaultQuotationFile }
      if (this.$refs.quotationFileRef) {
        this.$refs.quotationFileRef.value = null
      }
    },
    async createQuotation() {
      this.$store.commit('main/setShowSpinner', true)
      this.creatingQuotation = true
      try {
        const formData = new FormData()
        formData.append(
          'special_quotation',
          this.quotation.special_quotation ? 1 : 0
        )
        if (this.quotation.special_quotation) {
          formData.append(
            'additional_requirements',
            this.quotation.additional_requirements
          )
          if (this.quotation.quotationFile?.file) {
            formData.append(
              'specifications_file',
              this.quotation.quotationFile.file
            )
          }
        }
        formData.append('product_id', this.productData.id)

        if (!this.isSpecialQuote) {
          formData.append(
            'customization_id',
            this.customization.customization.id
          )
          formData.append('sale_volume_id', this.customization.sale_volume.id)
        }

        if (this.quotation.brand_id) {
          formData.append('brand_id', this.quotation.brand_id)
        }
        formData.append('channel_id', this.quotation.channel_id)
        formData.append('units', this.quotation.units)
        formData.append('number_of_positions', this.quotation.numberOfPositions)
        formData.append(
          'product_color_id',
          this.quotation.productColorSelected.id
        )
        await this.axios.post(
          'sales-operator/quotations/create-quotation',
          formData,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`,
              'Content-Type': 'multipart/form-data',
              Accept: 'application/json'
            }
          }
        )
        this.$store.commit('main/setQuotationCreated', true)
        this.$router.push('/quotations')
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.creatingQuotation = false
        window.scrollTo({ top: 0, behavior: 'smooth' })
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async addQuotationToCart() {
      this.$store.commit('main/setShowSpinner', true)
      this.creatingQuotation = true
      try {
        const formData = new FormData()
        formData.append(
          'special_quotation',
          this.quotation.special_quotation ? 1 : 0
        )
        if (this.quotation.special_quotation) {
          formData.append(
            'additional_requirements',
            this.quotation.additional_requirements
          )
          if (this.quotation.quotationFile?.file) {
            formData.append(
              'specifications_file',
              this.quotation.quotationFile.file
            )
          }
        }
        formData.append('product_id', this.productData.id)

        if (!this.isSpecialQuote) {
          formData.append(
            'customization_id',
            this.customization.customization.id
          )
          formData.append('sale_volume_id', this.customization.sale_volume.id)
        }

        if (this.quotation.brand_id) {
          formData.append('brand_id', this.quotation.brand_id)
        }
        formData.append('channel_id', this.quotation.channel_id)
        formData.append('units', this.quotation.units)
        formData.append('number_of_positions', this.quotation.numberOfPositions)
        formData.append(
          'product_color_id',
          this.quotation.productColorSelected.id
        )
        if (this.currentQuotation == undefined) {
          const response = await this.axios.post(
            'sales-operator/cart/add',
            formData,
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`,
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json'
              }
            }
          )
          this.$store.commit('cart/setCartData', response.data.multi_quotation)
          this.$store.commit(
            'cart/setCountQuotations',
            response.data.multi_quotation.quotations.length
          )
          this.$store.commit(
            'cart/setProductsInterests',
            response.data.product_interests
          )
          this.$toast.success('El producto se ha agregado al carrito', {
            position: 'top'
          })
        } else {
          const response = await this.axios.post(
            `sales-operator/cart/edit/${this.currentQuotation.id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`,
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json'
              }
            }
          )
          this.$store.commit('cart/setCartData', response.data.multi_quotation)
          this.$store.commit(
            'cart/setCountQuotations',
            response.data.multi_quotation.quotations.length
          )
          this.$store.commit(
            'cart/setProductsInterests',
            response.data.product_interests
          )
          this.$toast.success('El producto del carrito se ha actualizado', {
            position: 'top'
          })
        }
        setTimeout(() => this.$router.push('/catalogue'), 500)
      } catch (error) {
        console.log(error)
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.creatingQuotation = false
        window.scrollTo({ top: 0, behavior: 'smooth' })
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async updateQuotationStatus() {
      this.$store.commit('main/setShowSpinner', true)
      this.creatingQuotation = true
      try {
        const formData = new FormData()
        formData.append(
          'special_quotation',
          this.quotation.special_quotation ? 1 : 0
        )
        if (this.quotation.special_quotation) {
          formData.append(
            'additional_requirements',
            this.quotation.additional_requirements
          )
          if (this.quotation.quotationFile?.file) {
            formData.append(
              'specifications_file',
              this.quotation.quotationFile.file
            )
          }
        }
        formData.append('product_id', this.productData.id)

        if (!this.isSpecialQuote) {
          formData.append(
            'customization_id',
            this.customization.customization.id
          )
          formData.append('sale_volume_id', this.customization.sale_volume.id)
        }

        if (this.quotation.brand_id) {
          formData.append('brand_id', this.quotation.brand_id)
        }
        formData.append('channel_id', this.quotation.channel_id)
        formData.append('units', this.quotation.units)
        formData.append('number_of_positions', this.quotation.numberOfPositions)
        formData.append(
          'product_color_id',
          this.quotation.productColorSelected.id
        )
        await this.axios.post(
          `sales-operator/quotations/${this.quotation.id}/requote`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`,
              'Content-Type': 'multipart/form-data',
              Accept: 'application/json'
            }
          }
        )
        this.$router.push(`/sales-operator/quotation/${this.quotation.id}`)
      } catch (error) {
        console.log(error)
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.creatingQuotation = false
        window.scrollTo({ top: 0, behavior: 'smooth' })
        this.$store.commit('main/setShowSpinner', false)
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'auth/getCompany',
      urlOriginIsBrandIn: 'main/urlOriginIsBrandIn',
      releatedProducts: 'cart/getProductsInterests'
    }),
    labelTypePersonalization() {
      return Boolean(
        this.printingTypesFiltered
          ?.map((cItem) => cItem.customization)
          ?.filter(
            (cItem) =>
              cItem.print_type_id === this.printTypeId &&
              (cItem.print_type.name
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .includes('tampografia') ||
                cItem.print_type.name
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
                  .includes('serigrafia'))
          ).length
      )
    },
    isCpaCompany() {
      return this.company?.code == 'cpa'
    },
    isSpecialQuote() {
      return this.productData?.sku === 'COTESPI001'
    },
    minUnitsQuotation() {
      return this.productData && this.productData?.customizations?.length
        ? Math.min(
            ...this.productData.customizations
              .map((c) => c.sale_volume)
              .map((saleVolume) => saleVolume.minimum_units)
          )
        : 1
    },
    maxUnitsQuotation() {
      if (this.quotation.productColorSelected?.stock) {
        return this.quotation.productColorSelected?.stock
      } else {
        return this.productData && this.productData?.customizations?.length
          ? Math.max(
              ...this.productData.customizations
                .map((c) => c.sale_volume)
                .map((saleVolume) => saleVolume.maximum_units)
            )
          : 1
      }
    },
    masterBoxQuantity() {
      return this.productData?.containerbox?.masterbox?.max_total_containers &&
        this.quotation?.units
        ? Math.ceil(
            this.quotation.units /
              this.productData.containerbox.masterbox.max_total_containers
          )
        : '-'
    },
    daysApproxDelivery() {
      return this.productData?.containerbox?.masterbox && this.customization
        ? `${
            Number(this.customization.sale_volume.days_customization || 0) +
            Number(
              this.productData?.containerbox?.masterbox?.days_approx_shipping ||
                0
            )
          } días`
        : '-'
    },
    printingTypesFiltered() {
      return this.quotation?.units
        ? (this.productData?.customizations || []).filter(
            (productPrinting) =>
              this.quotation.units >=
                productPrinting?.sale_volume?.minimum_units &&
              this.quotation.units <=
                productPrinting?.sale_volume?.maximum_units
          )
        : []
    },
    printingTypes() {
      return this.printingTypesFiltered
        .map((item) => item.customization.print_type)
        .filter(
          (obj, index, self) => index === self.findIndex((o) => o.id === obj.id)
        )
    },
    printingTypesDescription() {
      return this.printingTypes?.map((type) => type.name)?.join(', ') || '-'
    },
    printingAreasDescription() {
      return (
        this.printingTypesFiltered
          ?.map((item) => item.customization?.personalization)
          ?.filter((personalization) => isNaN(personalization))
          ?.filter(
            (obj, index, self) => index === self.findIndex((o) => o === obj)
          )
          ?.join(', ') || '-'
      )
    },
    checkContainerBox() {
      return (
        this.productData?.containerbox?.length &&
        this.productData?.containerbox?.width &&
        this.productData?.containerbox?.height
      )
    },
    basePrice() {
      if (this.customization) {
        let indirect = 1
        let utility = 1
        if (this.company?.percentage_indirect_expenses) {
          indirect = 1 - this.company.percentage_indirect_expenses / 100
          utility = this.company.percentage_utility
            ? 1 - this.company.percentage_utility / 100
            : 1
        }

        const basePrice = Number(this.customization.base_price)
        const priceIndirect =
          Number(basePrice) / Number(indirect) - Number(basePrice)

        return Number(
          Number(
            Number(basePrice) +
              Number(priceIndirect) +
              Number(this.customization.sale_volume.cost_per_unit)
          ) / utility
        )
      } else {
        return 0
      }
    },
    priceQuotation() {
      return this.basePrice && this.quotation.units
        ? this.basePrice * Number(this.quotation.units) +
            Number(
              this.productData.containerbox.masterbox.base_delivery_price
            ) *
              this.masterBoxQuantity
        : 0
    },
    checkQuotation() {
      if (this.isCpaCompany) {
        if (!this.isSpecialQuote) {
          return (
            this.quotation &&
            Number(this.quotation.channel_id) >= 1 &&
            this.quotation.brand_id &&
            this.quotation.productColorSelected &&
            this.quotation.units &&
            this.quotation.units >= this.minUnitsQuotation &&
            this.quotation.units <= this.maxUnitsQuotation &&
            this.customization &&
            Number(this.quotation.numberOfPositions) >= 0 &&
            (!this.quotation.special_quotation ||
              (this.quotation.special_quotation &&
                this.quotation.additional_requirements))
          )
        } else {
          return (
            this.quotation &&
            Number(this.quotation.channel_id) >= 1 &&
            this.quotation.brand_id &&
            this.quotation.productColorSelected &&
            this.quotation.units &&
            this.quotation.additional_requirements &&
            this.quotation.quotationFile.file
          )
        }
      } else {
        if (!this.isSpecialQuote) {
          return (
            this.quotation &&
            this.quotation.productColorSelected &&
            this.quotation.units &&
            this.quotation.units >= this.minUnitsQuotation &&
            this.quotation.units <= this.maxUnitsQuotation &&
            this.customization &&
            Number(this.quotation.numberOfPositions) >= 0 &&
            (!this.quotation.special_quotation ||
              (this.quotation.special_quotation &&
                this.quotation.additional_requirements))
          )
        } else {
          return (
            this.quotation &&
            this.quotation.productColorSelected &&
            this.quotation.units &&
            this.quotation.additional_requirements &&
            this.quotation.quotationFile.file
          )
        }
      }
    },
    customization() {
      return (
        this.printingTypesFiltered?.find(
          (cItem) =>
            cItem.customization.id === this.customizationId &&
            cItem.customization.print_type_id === this.printTypeId
        ) || undefined
      )
    }
  },
  watch: {
    'productData.sku'(value) {
      if (value === 'COTESPI001') {
        this.quotation.special_quotation = true
      }
    },
    '$route.params': async function () {
      if (!this.creatingQuotation && this.$route.params?.id) {
        const productId = parseInt(this.$route.params.id)
        this.$store.commit('main/setShowSpinner', true)
        await Promise.all([
          this.setViewProduct(productId),
          this.getProductData(productId)
        ])
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    'quotation.units'(value) {
      this.printTypeId = undefined
      this.quotation.saleVolumeSelected =
        value >= this.minUnitsQuotation && value <= this.maxUnitsQuotation
          ? this.productData.customizations
              .map((c) => c.sale_volume)
              .find(
                (saleVolumeData) =>
                  saleVolumeData.minimum_units <= value &&
                  saleVolumeData.maximum_units >= value
              )
          : undefined
    },
    printTypeId(id) {
      this.customizationId = undefined
      const personalizationsSeen = new Set()
      this.customizationsFilter = this.printingTypesFiltered
        .filter((cItem) => cItem.customization.print_type_id === id)
        .reduce((acc, cItem) => {
          const personalization = cItem.customization.personalization
          if (personalizationsSeen.has(personalization)) {
            return acc
          }
          personalizationsSeen.add(personalization)
          acc.push({
            id: cItem.customization.id,
            name: personalization
          })
          return acc
        }, [])
    },
    customization(values) {
      if (values?.customization?.personalization === 'No aplica') {
        this.quotation.numberOfPositions = 0
      } else {
        this.quotation.numberOfPositions = 1
      }
    },
    'quotation.special_quotation'() {
      if (this.productData) {
        this.quotation.additional_requirements = undefined
        this.cleanFile()
      }
    },
    'quotation.client_id'() {
      if (this.productData) {
        const client = this.clients.find(
          (clientData) => clientData.id === this.quotation.client_id
        )
        this.quotation.brand_id = undefined
        this.brands = Array.isArray(client?.brands) ? client.brands : []
      }
    }
  }
}
</script>

<style scoped>
.bg-nav {
  background: url('@/assets/images/COT-bg/img-slider-nav.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: auto;
  width: auto;
}

.bg-banner-2 {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-geometria {
  background: url('@/assets/images/COT-bg/img-geometria.svg');
  background-repeat: no-repeat;
  background-position: center;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-cat-bg {
  background: url('@/assets/images/COT-bg/img-categorias.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 60px;
  width: auto;
  padding-top: 2px;
}

.bg-banner {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  backdrop-filter: blur(8px) brightness(100%);
  border: 3px solid rgba(255, 255, 255, 0.28);
}

.backtest {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-banner-cot {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 198px;
  width: auto;
  padding-top: 0px;
  margin-bottom: 18rem;
}

.bg-banner-cot-res {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 445px;
  width: auto;
  padding-top: 0px;
}

.bg-products-cot {
  background: url('@/assets/images/COT-bg/img-products.svg');
  background-repeat: no-repeat;
  background-position: inherit;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 230px;
  width: auto;
  padding-top: 2px;
}

.bg-help {
  background: url('@/assets/images/COT-bg/img-help.svg');
  background-repeat: no-repeat;
  background-position: right;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 350px;
  width: auto;
  padding-top: 2px;
}

.btn-deg {
  background: linear-gradient(89.75deg, #e85c04 0.17%, #faa306 99.78%);
  transition: 0.3s;
  outline: 1px solid transparent;
  width: 200px;
  font-weight: 600;
}

.b-cot-card {
  background-image: radial-gradient(
      circle at 100% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to right, #ffffff, #ffffff),
    radial-gradient(
      circle at 0% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to bottom, #ffffff, #f6f6e0),
    radial-gradient(
      circle at 0% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 21px
    ),
    linear-gradient(to left, #ffffff21, #ffffff21),
    radial-gradient(
      circle at 100% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 17px
    ),
    linear-gradient(to top, #ffffff21, #ffffff);
  background-size: 21px 21px, calc(100% - 42px) 3px, 21px 21px,
    3px calc(100% - 42px);
  background-position: top left, top center, top right, center right,
    bottom right, bottom center, bottom left, center left;
  background-repeat: no-repeat;
  border-radius: 24px;
}

.bg-card {
  background: #ffffff21;
  border-radius: 24px;
}

.eventos {
  background-image: url('@/assets/images/COT-img/eventos/fiestas-1.svg');
}

.flip-card {
  background-color: transparent;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  /* Note: backdrop-filter has minimal browser support */
  border-radius: 20px;
}

.flip-card-back {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  border-radius: 20px;
  transform: rotateY(180deg);
}

.brandin-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
}

/* SEARCH CONTROL CSS */
.form-control {
  border-color: transparent;
}

.input-group > .form-control:focus {
  border-color: transparent;
  box-shadow: inset 0 0 0 1px transparent;
}
.btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active,
.btn-link.active {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:focus,
.btn-link.focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active:focus,
.btn-link.active:focus {
  background-color: rgba(0, 0, 0, 0.05);
}

.i-search {
  border-radius: 6px 0px 0px 6px !important;
  background: rgb(241, 241, 241) !important;
  border-color: #cacaca !important;
  border-bottom-width: 1px !important;
  border-style: solid none solid solid !important;
  border-top-width: 1px !important;
  border-left-width: 1px !important;
  border-right-width: initial !important;
}
.i-search-form {
  background: rgb(241, 241, 241);
  border-color: #cacaca;
  border-bottom-width: 1px;
  border-style: solid solid solid none;
  border-top-width: 1px;
  border-right-width: 1px;
  border-left-width: initial;
  border-radius: 0px 6px 6px 0px;
  box-shadow: 0 0 0;
}
.color-picker {
  box-shadow: 0 0 0;
  width: 24px;
  height: 24px;
  border: none;
  display: inline-block;
  transition: 0.3s all;
  border-radius: 24px;
}
.color-picker:hover {
  -webkit-box-shadow: inset 0px 0px 0px 4px white;
  -moz-box-shadow: inset 0px 0px 0px 4px white;
  box-shadow: inset 0px 0px 0px 4px white;
}
.color-picker-active {
  -webkit-box-shadow: inset 0px 0px 0px 4px white;
  -moz-box-shadow: inset 0px 0px 0px 4px white;
  box-shadow: inset 0px 0px 0px 4px white;
}
.Aqua {
  background: aqua;
}
.White {
  background: #ffffffd6;
}
.Yellow {
  background: #faa306;
}

.Orange {
  background: #e85c04;
}
.Red {
  background: #ce0100;
}
.Beige {
  background: beige;
}
.Gray {
  background: gray;
}
.Pink {
  background: pink;
}
.Green {
  background: green;
}
.Blue {
  background: navy;
}
.Black {
  background: black;
}
.Purple {
  background: purple;
}

.form-check-input[type='checkbox']:checked {
  background-color: #faa306;
  width: 20px;
  height: 20px;
  border: none;
}
.form-check-input[type='checkbox'] {
  width: 20px;
  height: 20px;
  border: 1px solid #cacaca;
}
tr:nth-child(even) {
  background-color: #f1f1f1;
}
tr {
  background-color: white;
}
th {
  padding-left: 16px;
  padding-top: 6px;
  padding-bottom: 6px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
